import { useQuery } from "@tanstack/react-query";
import { ICompany } from "shared";
import { getCompany } from "../../api/Company";

export const useCompany = () => {
  return useQuery<ICompany>(["company"], getCompany);
};
